import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAudienceNoData = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 327,
	height: 158,
	viewBox: "0 0 327 158",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_3603_150531)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: .5,
					width: 196,
					height: 112,
					rx: 4,
					fill: "white",
					shapeRendering: "crispEdges"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 1.5,
					y: 1,
					width: 194,
					height: 110,
					rx: 3,
					stroke: "#6F6F76",
					strokeWidth: 2,
					shapeRendering: "crispEdges"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 9,
					y: 8.5,
					width: 91,
					height: 20,
					rx: .5,
					fill: "#ADC9FF",
					stroke: "#105ED5"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 9,
					y: 33.5,
					width: 91,
					height: 20,
					rx: .5,
					fill: "#C7DAFF",
					stroke: "#105ED5"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 9,
					y: 58.5,
					width: 91,
					height: 20,
					rx: .5,
					fill: "#ADC9FF",
					stroke: "#105ED5"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 9,
					y: 83.5,
					width: 91,
					height: 20,
					rx: .5,
					fill: "#EBF3FF",
					stroke: "#105ED5"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 105,
					y: 8.5,
					width: 47,
					height: 20,
					rx: .5,
					fill: "#C7DAFF",
					stroke: "#ADC9FF"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 105,
					y: 33.5,
					width: 47,
					height: 20,
					rx: .5,
					fill: "#EBF3FF",
					stroke: "#ADC9FF"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 105,
					y: 58.5,
					width: 47,
					height: 20,
					rx: .5,
					fill: "#C7DAFF",
					stroke: "#5599FF"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 105,
					y: 83.5,
					width: 47,
					height: 20,
					rx: .5,
					fill: "#ADC9FF",
					stroke: "#105ED5"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M157 9C157 8.72386 157.224 8.5 157.5 8.5H187.5C187.776 8.5 188 8.72386 188 9V28C188 28.2761 187.776 28.5 187.5 28.5H157.5C157.224 28.5 157 28.2761 157 28V9Z",
					fill: "#EBF3FF",
					stroke: "#5599FF"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 157,
					y: 33.5,
					width: 31,
					height: 20,
					rx: .5,
					fill: "#C7DAFF",
					stroke: "#5599FF"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 157,
					y: 58.5,
					width: 31,
					height: 20,
					rx: .5,
					fill: "#EBF3FF",
					stroke: "#5599FF"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 157,
					y: 83.5,
					width: 31,
					height: 20,
					rx: .5,
					fill: "#EBF3FF",
					stroke: "#5599FF"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter1_d_3603_150531)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 128.5,
					y: 44,
					width: 196,
					height: 112,
					rx: 4,
					fill: "white",
					shapeRendering: "crispEdges"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 129.5,
					y: 45,
					width: 194,
					height: 110,
					rx: 3,
					stroke: "#6F6F76",
					strokeWidth: 2,
					shapeRendering: "crispEdges"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 137,
					y: 52.5,
					width: 91,
					height: 20,
					rx: .5,
					fill: "#ADC9FF",
					stroke: "#105ED5"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 137,
					y: 77.5,
					width: 91,
					height: 20,
					rx: .5,
					fill: "#ADC9FF",
					stroke: "#105ED5"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 137,
					y: 102.5,
					width: 91,
					height: 20,
					rx: .5,
					fill: "#ADC9FF",
					stroke: "#105ED5"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 137,
					y: 127.5,
					width: 91,
					height: 20,
					rx: .5,
					fill: "#ADC9FF",
					stroke: "#105ED5"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 233,
					y: 52.5,
					width: 47,
					height: 20,
					rx: .5,
					fill: "#C7DAFF",
					stroke: "#5599FF"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 233,
					y: 77.5,
					width: 47,
					height: 20,
					rx: .5,
					fill: "#C7DAFF",
					stroke: "#5599FF"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 233,
					y: 102.5,
					width: 47,
					height: 20,
					rx: .5,
					fill: "#C7DAFF",
					stroke: "#5599FF"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 233,
					y: 127.5,
					width: 47,
					height: 20,
					rx: .5,
					fill: "#C7DAFF",
					stroke: "#5599FF"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 285,
					y: 52.5,
					width: 31,
					height: 20,
					rx: .5,
					fill: "#EBF3FF",
					stroke: "#5599FF"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 285,
					y: 77.5,
					width: 31,
					height: 20,
					rx: .5,
					fill: "#EBF3FF",
					stroke: "#5599FF"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 285,
					y: 102.5,
					width: 31,
					height: 20,
					rx: .5,
					fill: "#EBF3FF",
					stroke: "#5599FF"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 285,
					y: 127.5,
					width: 31,
					height: 20,
					rx: .5,
					fill: "#EBF3FF",
					stroke: "#5599FF"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_3603_150531",
			x: .5,
			y: 0,
			width: 198,
			height: 114,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: 2,
					dy: 2
				}),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.435294 0 0 0 0 0.435294 0 0 0 0 0.462745 0 0 0 1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_3603_150531"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_3603_150531",
					result: "shape"
				})
			]
		}), /* @__PURE__ */ _jsxs("filter", {
			id: "filter1_d_3603_150531",
			x: 128.5,
			y: 44,
			width: 198,
			height: 114,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: 2,
					dy: 2
				}),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.435294 0 0 0 0 0.435294 0 0 0 0 0.462745 0 0 0 1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_3603_150531"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_3603_150531",
					result: "shape"
				})
			]
		})] })
	]
});
export { SvgAudienceNoData as ReactComponent };
